function scrollArrow() {
  const $scrollToTop = $('.scroll-to-top');
  const $scrollToBottom = $('.scroll-to-bottom');
  $(window).scroll(() => {
    if ($(window).scrollTop() >= 100) {
      $scrollToTop.fadeIn();
      $scrollToBottom.fadeOut();
    } else {
      $scrollToTop.fadeOut();
      $scrollToBottom.fadeIn();
    }
  });
  $scrollToTop.click(() => {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      600,
    );
  });
  $scrollToBottom.click(() => {
    $('html, body').animate(
      {
        scrollTop: 800,
      },
      600,
    );
  });
}

scrollArrow();
